module.exports = __webpack_public_path__ + "static/media/x.d54fea31.svg";